import { Action } from '@ngrx/store';
import { CustomPlpState } from './custom-plp.state';

export enum CustomPlpActionTypes {
    LOAD_CUSTOMPLP_CONFIG_CONTENT = '[Catalog] CustomPlp Load',
    LOAD_CUSTOMPLP_CONFIG_CONTENT_SUCCESS = '[Catalog] CustomPlp Load Success',
    LOAD_CUSTOMPLP_CONFIG_CONTENT_FAILURE = '[Catalog] CustomPlp Load Failure'
}

export class LoadCustomPlpConfigContent implements Action {
    readonly type = CustomPlpActionTypes.LOAD_CUSTOMPLP_CONFIG_CONTENT;

    constructor(public payload: string) {}
}

export class LoadCustomPlpConfigContentSuccess implements Action {
    readonly type = CustomPlpActionTypes.LOAD_CUSTOMPLP_CONFIG_CONTENT_SUCCESS;

    constructor(public payload: { response: CustomPlpState} ) {
    }
}

export class LoadCustomPlpConfigContentFailure implements Action {
    readonly type = CustomPlpActionTypes.LOAD_CUSTOMPLP_CONFIG_CONTENT_FAILURE;

    constructor(public payload: {error: any}) {
    }
}

export type CustomPlpActionsUnion = LoadCustomPlpConfigContent
| LoadCustomPlpConfigContentSuccess
| LoadCustomPlpConfigContentFailure;
